<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-14 23:33:08
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-qyry.vue
 * @Description: 企业荣誉
-->
<template>
  <div class="qyry">
    <div class="content" v-loading="loading.qyry">
      <div class="scroll-list" style="height: 90px" v-if="!loading.qyry">
        <vue-seamless-scroll :class-option="classOption" :data="qyry">
          <div class="list-item" v-for="(item, index) in qyry" :key="index">
            <el-row :gutter="20">
              <el-col :span="6" class="text-overflow">{{ item.name }}</el-col>
              <el-col :span="18" class="text-overflow">{{
                item.describe
              }}</el-col>
            </el-row>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('company-profile', ['loading', 'qyry']),
    classOption () {
      return {
        // 配置超出容器才开始滚动
        limitMoveNum: true,
        // 速度
        step: 3,
        // 鼠标停止
        hoverStop: true,
        // 0 下 1 上 2 左 3 右
        direction: 1,
        singleHeight: 30,
        waitTime: 5000
      }
    }
  },
  methods: {
    ...mapActions('company-profile', ['getQYRY'])
  },
  created () {
    this.getQYRY()
  }
}
</script>

<style lang="scss">
.qyry {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    margin: 0 auto;
    width: calc(100% - 50px);
    .scroll-list {
      overflow: hidden;
      .list-item {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
